import { createContext } from '@wordpress/element';
import { useDispatch, useSelect } from '@wordpress/data';
import { store as coreStore, useEntityProp } from '@wordpress/core-data';
import { store as noticesStore } from '@wordpress/notices';
import { __ } from '@wordpress/i18n';

export const SettingsContext = createContext();

function SettingsContextProvider( props ) {
	const [ settings ] = useEntityProp( 'root', 'site', 'popper' );

	const { saveEditedEntityRecord } = useDispatch( coreStore );
	const { createNotice } = useDispatch( noticesStore );

	const saveSettings = () => {
		return saveEditedEntityRecord( 'root', 'site' )
			.then( () => {
				createNotice(
					'info',
					'🎯 ' + __( 'Settings saved.', 'popper' ),
					{
						type: 'snackbar',
					}
				);
			} )
			.catch( ( error ) => {
				createNotice( 'error', '⚠️ ' + error.message, {
					type: 'snackbar',
					explicitDismiss: true,
				} );
			} );
	};

	const { isSaving, hasEdits } = useSelect(
		( select ) => ( {
			isSaving: select( coreStore ).isSavingEntityRecord(
				'root',
				'site'
			),
			hasEdits: select( coreStore ).hasEditsForEntityRecord(
				'root',
				'site',
				undefined,
				'popper'
			),
		} ),
		[]
	);

	return (
		<SettingsContext.Provider
			value={ {
				saveSettings,
				settings,
				hasUpdates: hasEdits,
				isSaving,
			} }
		>
			{ props.children }
		</SettingsContext.Provider>
	);
}

export default SettingsContextProvider;
